import styled from "styled-components";

export const RatingDistributionStyles = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  padding: 8px 4px 0;
  gap: 8px;
  height: 200px;

  .histo-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
  }

  .histo-bar-wrap {
    flex: 1;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0 6px;
  }

  .histo-bar {
    width: 100%;
    max-width: 56px;
    min-height: 4px;
    border-radius: 6px 6px 0 0;
    position: relative;
    transition: opacity 0.15s ease;
  }
  .histo-bar:hover {
    opacity: 0.85;
  }

  .histo-count {
    position: absolute;
    top: -18px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .histo-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 8px;
  }

  .histo-grade {
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    display: flex;
    gap: 1px;
    align-items: center;
  }

  .histo-star {
    color: #e0a800;
    font-size: 12px;
    margin-left: 1px;
  }

  .histo-share {
    font-size: 10px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    margin-top: 2px;
  }
`;
